import { useMemo } from 'react';

import { useSearchParams } from 'react-router-dom';

export const useQueryParam = (key: string) => {
  const [searchParams] = useSearchParams();

  return useMemo(() => searchParams.get(key), [key, searchParams]);
};
